const priceHelper = {
  isZero(value: string) {
    return value === '€ 0,00'
  }
}

export {priceHelper}
